import { IHowToHireTeamStep } from '@components/services/dedicated-teams/dedicated-teams.state';
import template from '@components/services/services.module.scss';
import style from './how-to-hire-team.module.scss';

interface IHowToHireTeamProps {
  title: string;
  steps: IHowToHireTeamStep[];
}

const HowToHireTeamSection = ({ title, steps }: IHowToHireTeamProps) => {
  return (
    <section className={`${template.section} ${template.section_light} ${template.container_large} ${style.section}`}>
      <div className={`${template.container} ${style.step_header}`}>
        <h2 className={`${template.title} ${template.title_large} ${style.title}`}>{title}</h2>
      </div>
      <div className={`${template.container_large} ${style.step_wrapper}`}>
        {steps.map((step: IHowToHireTeamStep, index: number) => {
          return (
            <div key={index} className={`${style.step_item}`}>
              <div className={`${style.step__header__wrapper}`}>
                <div className={`${style.step_number}`}>{step.id}</div>
                <div className={`${style.step__header__wrapper_title}`}>{step.title}</div>
              </div>
              {step.description.map((descriptionItem: string, index: number) => {
                return (
                  <div key={index} className={`${template.text_small} ${style.step_description} ${template.fw400}`}>
                    {descriptionItem}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HowToHireTeamSection;
